<template>
  <div>
    <div v-if="!loadedCampaigns">Loading Campaigns...</div>
    <div v-else>
      <div>
        <div v-if="false" class="filters">
          <div>Filters:</div>
          <div class="causes-filters-container">
            <div
              v-for="(cause, cci) in campaignCauses"
              :key="`campaignCause_${cci}`"
              class="filter-item"
            >
              <input
                type="checkbox"
                :id="`campaignCause_${cci}`"
                :name="`campaignCause_${cci}`"
                v-model="causesFilter"
                :value="cause"
              />
              <label :for="`campaignCause_${cci}`">{{ titleCase(cause) }}</label>
            </div>
          </div>
        </div>
        <div id="top-buttons-container">
          <div class="checkout-button-container top-btn">
            <button :disabled="!cart.length" @click="checkout">
              Checkout ({{ cart.length }})
            </button>
          </div>
          <button
            class="btn btn-dark ml-auto top-btn"
            type="button"
            @click="popupFix"
            v-if="false && !access_token"
          >
            Login
          </button>
          <div v-if="access_token" class="top-btn">
            <div class="button-end">
              <button
                class="btn btn-dark ml-auto"
                type="button"
                @click="logout"
                v-if="access_token"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="campaign-card">
            <div class="campaigns-cards-container">
              <div class="campaigns-card">
                <div>
                  <span>
                    <h3>
                      <strong class="campaign-title">Main Donation Page</strong>
                    </h3>
                  </span>
                </div>
                <div class="campaign-img-container">
                  <img class="campaign-img" :src="horizontalLogo" />
                </div>
                <div class="campaign-details-container">
                  <div>
                    <span>
                      <span>Description: </span>
                      <strong class="campaign-description"
                        >Ronald McDonald House Charities Singapore was founded in 1989,
                        and belongs to a global network of over 260 chapters in 62
                        countries. We are an independently administered charity with a
                        simple mission - to directly improve the health and well-being of
                        children in Singapore.</strong
                      >
                    </span>
                  </div>
                  <div>
                    <span>
                      <span>Created by: </span>
                      <div class="creator-img-container">
                        <img class="creator-img" :src="horizontalLogo" />
                      </div>
                      <div class="creator-text">
                        <strong>Ronald McDonald House Charities Singapore</strong>
                      </div>
                    </span>
                  </div>
                  <div>
                    <span>
                      <span>Causes: </span>
                      <strong>{{
                        ["children_youth", "community", "families", "health"]
                          .map((c) => titleCase(c))
                          .join(", ")
                      }}</strong>
                    </span>
                  </div>
                </div>
                <div>
                  <button class="donate-button" @click="openMainDonatePage">
                    Donate
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="(campaign, cti) in campaigns"
            :key="`campaignType_${cti}`"
            class="campaign-card"
          >
            <!-- <h1>{{titleCase(campaignType)}} ({{campaignsSorted[campaignType].length}} Result(s))</h1> -->
            <div class="campaigns-cards-container">
              <div class="campaigns-card" :key="`campaign_${cti}`">
                <div>
                  <span>
                    <h3>
                      <strong class="campaign-title">{{ campaign.title }}</strong>
                    </h3>
                  </span>
                </div>
                <div class="campaign-img-container">
                  <img class="campaign-img" :src="horizontalLogo" />
                </div>
                <div class="campaign-details-container">
                  <div>
                    <span>
                      <span>Description: </span>
                      <strong class="campaign-description">{{
                        campaign.description
                      }}</strong>
                    </span>
                  </div>
                  <div>
                    <span>
                      <span>Created by: </span>
                      <div class="creator-img-container">
                        <img class="creator-img" :src="horizontalLogo" />
                      </div>
                      <div class="creator-text">
                        <strong>{{ campaign.creatorName }}</strong>
                      </div>
                    </span>
                  </div>
                  <div>
                    <span>
                      <span>Status: </span>
                      <strong :class="`campaign-${campaign.status}`">{{
                        titleCase(campaign.status)
                      }}</strong>
                    </span>
                  </div>
                  <div>
                    <span>
                      <span>Duration: </span>
                      <strong
                        >{{ dateFormat(campaign.startDate) }} -
                        {{ dateFormat(campaign.endDate) }}</strong
                      >
                    </span>
                  </div>
                  <div class="amount-raised">
                    <span>
                      <span>Amount raised: </span>
                      <k-progress
                        :color="['#f5af19', '#f12711', '#9254de', '#40a9ff', '#5cdbd3']"
                        :color-flow="true"
                        :percent="
                          getPercent(campaign.amountRaised, campaign.fundraisingGoal)
                        "
                        :format="getPercentFloor"
                        :line-height="12"
                      />
                      <strong
                        >SGD {{ campaign.amountRaised }} /
                        {{ campaign.fundraisingGoal }} by
                        {{ campaign.donors }} donor(s)</strong
                      >
                    </span>
                  </div>
                </div>
                <div>
                  <button
                    class="donate-button"
                    @click="
                      /* showAddToCartModal(
                        campaign.charityId,
                        campaign.id,
                        campaign.creatorType
                      )*/
                      redirectToGivingSg(campaign.title)"
                  >
                    Donate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-final-modal
      classes="modal-container"
      content-class="modal-content"
      v-model="showModal"
    >
      <div v-if="activeModal === 'addToCart'" class="the-pad">
        Donate to <strong>{{ activeCampaignModal.title }}</strong>
        <div>
          <button
            v-for="(d, i) in donationsPresets"
            class="donate-button"
            @click="donateAmount(d)"
            :key="'donation_' + i"
          >
            Donate ${{ d }}
          </button>
        </div>
        <div>
          <label> Other amount: </label>
          <input
            v-model="activeCampaignModalData.donationAmount"
            type="number"
            min="10"
            @keydown="
              (evt) => ['e', 'E', '+', '-'].includes(evt.key) && evt.preventDefault()
            "
          />
        </div>
        <div>
          <button
            class="donate-button"
            @click="donateAmount(activeCampaignModalData.donationAmount, true)"
          >
            Donate Today
          </button>
        </div>
      </div>

      <div v-if="activeModal === 'checkout'" class="the-pad">
        <div v-if="!paymentPageHTML">
          <strong>Your cart:</strong>
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Campaign</th>
                  <th scope="col">Amount</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(campaign, i) in cart"
                  :key="'campaign_' + campaign.beneficiaryId"
                >
                  <td>{{ getCampaignName(campaign.beneficiaryId) }}</td>
                  <td>SGD {{ campaign.donationAmount }}</td>
                  <td>
                    <button @click="removeFromCart(i)">Remove</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div>
              <h2>Donor information:</h2>
            </div>
            <div>
              <label>
                <input type="checkbox" v-model="cartInformation.claimTDR" />
                Claim Tax Deduction Receipts
              </label>
              <label class="padding-left">
                <input
                  type="checkbox"
                  :disabled="cartInformation.claimTDR"
                  v-model="cartInformation.isAnonymous"
                />
                Remain as an anonymous donor
              </label>
              <div v-if="!cartInformation.isAnonymous">
                <div>
                  <label> Salutation: </label>
                  <select v-model="additionalInfo.salutation">
                    <option
                      v-for="salutationOption in salutationOptions"
                      :key="`salutation_${salutationOption.value}`"
                      :value="salutationOption.value"
                    >
                      {{ salutationOption.text }}
                    </option>
                  </select>
                </div>
                <div>
                  <label> Name: </label>
                  <input type="text" v-model="additionalInfo.nricName" />
                </div>
                <div v-if="cartInformation.claimTDR">
                  <label> NRIC Number: </label>
                  <input type="text" v-model="additionalInfo.nricNumber" />
                </div>
              </div>
              <div>
                <label> Postal Code: </label>
                <input type="text" v-model="additionalInfo.postalCode" />
              </div>
              <div>
                <label> Building Name (optional): </label>
                <input type="text" v-model="additionalInfo.buildingName" />
              </div>

              <div>
                <label> Street Name (optional): </label>
                <input type="text" v-model="additionalInfo.streetName" />
              </div>
            </div>
            <div>
              <button
                class="donate-button"
                :disabled="generating"
                @click="generatePaymentPage"
              >
                {{
                  generating
                    ? "Generating Payment Page. Please wait..."
                    : `Go to Payment Page`
                }}
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <iframe class="payment-iframe" :srcdoc="paymentPageHTML"></iframe>
        </div>
      </div>

      <button class="modal-close" @click="showModal = false">x</button>
    </vue-final-modal>
  </div>
</template>

<script>
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css"; // optional for styling

const dummy = false;
//const client_id = 'ZMG02zdFH49aLR3oejSjOeuq2geCKixd'// production
//const secret = 'nLAP0RSPmlTioGaa' //production
const client_id = dummy
  ? "mdcRzkvoiuTSU4UOMc6fdyhxdjZLZAP5"
  : "ZMG02zdFH49aLR3oejSjOeuq2geCKixd";
const secret = dummy ? "0O2eGmzE0L34HuGE" : "nLAP0RSPmlTioGaa";

const apiBase = "https://rmhc.sg:2053";
const redirect_uri = `${apiBase}/redirect`;
import { VueFinalModal } from "vue-final-modal";
import KProgress from "k-progress";

import axios from "axios";
import dayjs from "dayjs";

const givingSgRmhcMainPage =
  "https://www.giving.sg/ronald-mcdonald-house-charities-singapore";

export default {
  name: "LoginApp",
  components: {
    VueFinalModal,
    KProgress,
  },
  data() {
    return {
      code: null,
      activeModal: "addToCart",
      access_token: null,
      refresh_token: null,
      token_type: null,
      generating: false,
      axios_config: {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Basic ${btoa(client_id + ":" + secret)}`,
          "x-apikey": client_id,
          Accept: "application/json",
        },
      },
      campaigns: [],
      loadedCampaigns: false,
      causesFilter: [],
      showModal: false,
      cart: [],
      activeCampaignModalData: {
        campaignId: null,
        beneficiaryId: null,
        beneficiaryType: "campaign",
        donationAmount: "10",
      },
      cartInformation: {
        claimTDR: false,
        isAnonymous: false,
      },
      additionalInfo: {
        salutation: "",
        nricName: "",
        nricNumber: "",
        postalCode: "",
        buildingName: "",
        streetName: "",
      },
      salutationOptions: [
        { text: "Mr", value: "mr" },
        { text: "Ms", value: "ms" },
        { text: "Mrs", value: "mrs" },
        { text: "Miss", value: "miss" },
        { text: "Madam", value: "mdm" },
        { text: "Dr", value: "dr" },
      ],
      paymentPageHTML: null,
      donationsPresets: [10, 50, 100, 200],
      horizontalLogo: "https://rmhc.sg/wp-content/uploads/2021/09/Logo.jpg",
    };
  },
  computed: {
    activeCampaignModal() {
      const activeId = this.activeCampaignModalData.campaignId;
      if (!activeId) {
        return {};
      }
      return this.campaigns.find((c) => c.id === activeId);
    },
    campaignCauses() {
      const cs = this.campaigns;
      const types = [...new Set([cs.map((c) => c.causes)].flat().flat())];
      return types;
    },
    campaignsSorted() {
      const cs = this.campaigns;
      if (!cs.length) {
        return [];
      }

      const types = [...new Set(cs.map((c) => c.creatorType))];

      const obj = {};

      for (let type of types) {
        obj[type] = [];
      }

      if (!this.causesFilter.length) {
        cs.forEach((c) => {
          obj[c.creatorType].push(c);
        });
      } else {
        cs.forEach((c) => {
          if (this.causesFilter.some((e) => c.causes.includes(e))) {
            obj[c.creatorType].push(c);
          }
        });
      }
      return obj;
    },
    url() {
      const scopes = ["read:campaign", "read:donation", "write:donation"].join(" ");
      return `https://${
        dummy ? "preprod-" : ""
      }api.giving.sg/v1/oauth2gsg/authorize?client_id=${client_id}&response_type=code&redirect_uri=${redirect_uri}&scope=${scopes}`;
    },
  },
  watch: {
    async showModal(val) {
      if (!val && this.activeModal === "checkout" && this.paymentPageHTML) {
        this.campaigns = (await this.getCampaigns()).items;
      }
    },
    cartInformation: {
      handler(val) {
        if (val.claimTDR) {
          this.cartInformation.isAnonymous = false;
        }

        if (val.isAnonymous) {
          this.additionalInfo.nricName = "";
        }
      },
      deep: true,
    },
  },
  async mounted() {
    window.addEventListener("message", this.onMessage, false);
    this.campaigns = (await this.getCampaigns()).items;
    this.loadedCampaigns = true;

    const access_token = localStorage.getItem("access_token");
    const refresh_token = localStorage.getItem("refresh_token");
    const token_type = localStorage.getItem("token_type");

    if (access_token) {
      this.access_token = access_token;
      this.refresh_token = refresh_token;
      this.token_type = token_type;
    }
    await this.$nextTick();
    tippy(".campaign-description", {
      content: (reference) => reference.textContent,
    });
    tippy(".campaign-title", {
      content: (reference) => reference.textContent,
    });
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onMessage);
  },
  methods: {
    urlify(title) {
      return title?.toLowerCase()?.replace(/[^A-Z0-9]+/ig, "_") || title;
    },
    redirectToGivingSg(title) {
      const GivingSgCampaignsUrl = 'https://www.giving.sg/campaigns/';
      window.open(`${GivingSgCampaignsUrl}${this.urlify(title)}`, "_blank")
    },
    removeFromCart(index) {
      const result = confirm("Remove this item from your cart?");
      if (!result) {
        return;
      }

      this.cart.splice(index, 1);
      if (!this.cart.length) {
        this.showModal = false;
      }
    },
    donateAmount(amt, custom) {
      if (!custom) {
        this.activeCampaignModalData.donationAmount = amt;
      }

      if (amt < 10) {
        alert("Please enter the minimum amount of SGD$10");
        return;
      }

      this.addToCart(+this.activeCampaignModalData.beneficiaryId);

      const result = confirm("Proceed to checkout now?");

      if (result) {
        this.checkout();
      }
    },
    openMainDonatePage() {
      window.open(givingSgRmhcMainPage, "_blank");
    },
    getPercent(num, denom) {
      let result = (num / denom) * 100;
      if (result > 100) {
        return 100;
      }
      return result;
    },
    getPercentFloor(num) {
      return Math.floor(num) + "%";
    },
    async generatePaymentPage() {
      this.generating = true;

      const finalAdditionalInfo = JSON.parse(JSON.stringify(this.additionalInfo));

      if (!this.cartInformation.claimTDR) {
        delete finalAdditionalInfo.nricNumber;
      }

      const payload = {
        ...this.cartInformation,
        additionalInfo: finalAdditionalInfo,
        cartItems: this.cart.map((c) => {
          return { ...c, beneficiaryId: +c.beneficiaryId };
        }),
      };
      const config = {
        headers: {
          Authorization: `Bearer ${this.access_token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      const { data: res } = await this.$post(
        `${apiBase}/donations/checkout`,
        payload,
        config
      );
      if (!res.transactionRef) {
        this.showModal = false;
        this.logout();
        this.popupFix(true);
        return;
      }

      const paymentPagePayload = { transactionRef: res.transactionRef };

      const { data, headers } = await this.$post(
        `${apiBase}/donations/generatePaymentPage`,
        paymentPagePayload,
        config
      );
      if (headers["content-type"] !== "text/html; charset=utf-8") {
        return;
      }

      this.paymentPageHTML = data;
      this.generating = false;
      const { data: trans } = await this.$get(
        `${apiBase}/donations/transaction/${res.transactionRef}`,
        config
      );
      console.log(trans);
      this.cart = [];
    },
    getCampaignName(id) {
      return this.campaigns.find((c) => c.id == id).title;
    },
    getCharityIdFromCampaignId(campaignId) {
      return this.campaigns.find((c) => c.id == campaignId).charityId;
    },
    addToCart(id) {
      console.log(this.cart,id)
      const itemIndex = this.cart.findIndex((c) => c.beneficiaryId === id);
      if (itemIndex !== -1) {
        this.cart[itemIndex].donationAmount = +this.activeCampaignModalData
          .donationAmount;
        this.cart[itemIndex].beneficiaryId = +this.activeCampaignModalData.campaignId;
        delete this.cart[itemIndex].campaignId;
      } else {
        const pl = JSON.parse(JSON.stringify(this.activeCampaignModalData));
        pl.donationAmount = +pl.donationAmount;
        pl.beneficiaryId = +pl.campaignId;
        delete pl.campaignId;
        this.cart.push(pl);
      }

      this.showModal = false;
    },
    showAddToCartModal(id, campaignId) {
      this.activeModal = "addToCart";
      this.activeCampaignModalData.campaignId = campaignId;
      this.activeCampaignModalData.beneficiaryId = id;
      this.activeCampaignModalData.beneficiaryType = "campaign";

      this.showModal = true;
    },
    checkout() {
      // if (!this.access_token) {
      //   this.popupFix(true);
      //   return;
      // }

      this.activeModal = "checkout";
      this.showModal = true;
    },
    dateFormat(date) {
      return dayjs(date).format("DD/MM/YYYY");
    },
    titleCase(str) {
      if (str === "npo") {
        return "Online Campaigns";
      }

      let result = str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });

      return result.replace(/^_*(.)|_+(.)/g, (s, c, d) =>
        c ? c.toUpperCase() : " " + d.toUpperCase()
      );
    },
    logout() {
      this.access_token = this.refresh_token = this.token_type = "";
      this.clearLogin();
    },
    clearLogin() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("token_type");
    },
    commitLoggedIn(res) {
      this.access_token = res.access_token;
      this.refresh_token = res.refresh_token;
      this.token_type = res.token_type;

      localStorage.setItem("access_token", this.access_token);
      localStorage.setItem("refresh_token", this.refresh_token);
      localStorage.setItem("token_type", this.token_type);
    },
    $post(url, payload, config = null) {
      if (!config) {
        config = this.axios_config;
      }
      return axios.post(url, payload, config);
    },
    $get(url, config = null) {
      if (!config) {
        config = this.axios_config;
      }
      return axios.get(url, config);
    },
    async getCampaigns() {
      const { data } = await this.$get(`${apiBase}/campaigns`, {});
      return data;
    },

    ShowAuthWindow(options) {
      options.windowName = options.windowName || "ConnectWithOAuth"; // should not include space for IE
      options.windowOptions =
        options.windowOptions || "location=50,status=0,width=552,height=458";
      options.callback =
        options.callback ||
        function () {
          window.location.reload();
        };
      var that = this;
      that._oauthWindow = window.open(
        options.path,
        options.windowName,
        options.windowOptions
      );
      that._oauthInterval = window.setInterval(function () {
        if (that._oauthWindow.closed) {
          window.clearInterval(that._oauthInterval);
          options.callback();
        }
      }, 500);
    },
    popupFix(from_login = false) {
      this.ShowAuthWindow({
        path: this.url,
        callback: () => {
          if (!this.code) {
            alert("Failed");
            return;
          }

          if (from_login) {
            this.generating = false;
            setTimeout(() => {
              this.checkout();
            }, 1000);
          }
        },
      });
    },
    onMessage(e) {
      const code = e.data.code;
      if (code) {
        this.code = code;
        this.tryAuth();
      }
    },
    async tryAuth() {
      const payload = new URLSearchParams();
      payload.append("grant_type", "authorization_code");
      payload.append("code", this.code);
      payload.append("redirect_uri", redirect_uri);

      const { data: res } = await this.$post(
        `https://${dummy ? "preprod-" : ""}api.giving.sg/v1/oauth2gsg/token`,
        payload
      );
      if (res.access_token) {
        this.commitLoggedIn(res);
        const campaigns = await this.getCampaigns();
        this.campaigns.items = campaigns.items;
        this.loadedCampaigns = true;
      }
    },
  },
};
</script>

<style>
.causes-filters-container {
  display: flex;
}

.campaigns-cards-container {
  display: flex;
  flex-wrap: wrap;
}

.campaigns-card {
  padding: 15px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin: 10px;
  max-width: 350px;
}

.donate-button {
  width: 100%;
  padding: 10px;
  margin-top: 31px;
  margin-bottom: 5px;
}

.campaign-img-container {
  display: none;
  justify-content: center;
  margin: 10px;
}

.campaign-img {
  max-width: 100px !important;
}
.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  position: relative;
  width: 80%;
  padding: 16px;
  overflow: auto;
  background-color: #fff;
  border-radius: 4px;
}
.modal-close {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  margin: 8px 8px 0 0;
  cursor: pointer;
}
.modal-close::hover {
  color: gray;
}

.checkout-button-container {
  display: flex;
  justify-content: flex-end;
}

.checkout-button-container button {
  border: none !important;
}

.checkout-button-container button:hover {
  border: var(--e-global-color-primary) !important;
}

.button-end {
  display: flex;
  justify-content: flex-end;
}

.filter-item {
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.filter-item input {
  margin-right: 5px;
}

.campaign-active {
  color: green;
}

.payment-iframe {
  width: 94%;
  height: 250px;
  border: none;
}

.the-pad {
  padding: 50px;
}

.campaign-title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  height: 37px;
}

.campaign-description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom: 21px;
}

.campaign-details-container {
  height: 477px;
}

.padding-left {
  padding-left: 20px;
}

.creator-img-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.creator-img {
  height: 103px !important;
  margin: 20px 0px;
}

.donate-btn-page {
  background: #da1a00;
  padding: 10px 20px;
  border: 1px solid #da1a00;
  border-radius: 3px;
  color: white !important;
}

.wrap {
  display: flex;
  flex-wrap: wrap;
}

.amount-raised {
  margin: 20px 0px;
}

.creator-text {
  height: 55px;
}

#top-buttons-container {
  display: flex;
  justify-content: flex-end;
}

.top-btn {
  margin: 5px;
}
</style>
